import Firebase from '../../lib/Firebase';
import Firestore from '../../lib/Firestore';


export default {
  all() {
    return Firebase.firestore().collection('chapters')
        .get()
        .then((docs) => {
            return Firestore.getCollectionData(docs);
        });
},
  user(uid) {
    return Firebase.firestore().collection('users').doc(uid)
        .get()
        .then((docs) => {
            return Firestore.getDocData(docs);
        });
},
retriveFiles(c){
  return Firebase.firestore().collection('chapters')
    .doc(c.docId)
    .collection('files')
    
    .get()
    .then((docs) => {
      return Firestore.getCollectionData(docs);
    });
},

  topics(){
    return Firebase.firestore().collection('topics')
    .get()
    .then((docs) => {
      return Firestore.getCollectionData(docs);
    });
  },
  
 
};


// WEBPACK FOOTER //
// ./src/pages/dashboard/service.js